import upload from './upload.vue';

upload.install = (VueInstance) => {
  VueInstance.component('c-upload', upload);
};

export default upload;